import React from 'react';
import ProcessPipeline from './ProcessPipeline';

const Model = () => {
  return (
    <section id="how-it-works" className="bg-brand-soft py-20 md:py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-brand-blue text-[12px] font-bold tracking-[0.16em] uppercase mb-4">
            The model
          </p>
          <h2 className="text-navy font-black tracking-[-0.01em] leading-[1.12] text-[32px] sm:text-[40px] md:text-[46px]">
            Launch a lead generation business in days, not months
          </h2>
          <p className="mt-6 text-body-muted text-[16px] leading-[1.7]">
            No new hires. No product build. No risk to the audience you already own.
          </p>
        </div>

        <ProcessPipeline />
      </div>
    </section>
  );
};

export default Model;
